// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span.CopyButton {\n    position: relative;\n}\n\nspan.copybutton-tooltip {\n    position: absolute;\n    visibility: hidden;\n    background-color: rgba(0, 0, 0, 0.75);\n    border: 1px solid black;\n    color: white;\n    font-size: 75%;\n    font-weight: normal;\n    padding: 0.5em;\n    border-radius: 0.5em;\n    top: 110%;\n    white-space: nowrap;\n}\n\nspan.CopyButton:hover span.copybutton-tooltip {\n    visibility: visible;\n}\n", ""]);
// Exports
module.exports = exports;
